import { LoadingState, logger } from '@vista/omnichannel-components-domain';
import { handleApiError } from '../../../subcomponents/showtime-picker/utils/showtime-picker-utils';
import { DateShowtimePickerActionType as ActionType } from './action-type';
export const dateShowtimePickerActionReducer = (state, action) => {
    switch (action.type) {
        case ActionType.Loading:
            return Object.assign(Object.assign({}, state), { filmsLoadingState: LoadingState.Loading, apiErrorMessageType: undefined });
        case ActionType.FailedToLoad:
            return Object.assign(Object.assign({}, state), { filmsLoadingState: LoadingState.Failure, apiErrorMessageType: handleApiError(action.error) });
        case ActionType.Loaded:
            return Object.assign(Object.assign({}, state), { filmsLoadingState: LoadingState.Success });
        case ActionType.LoadingAllFilms:
            return Object.assign(Object.assign({}, state), { isLoadingAllFilms: true });
        case ActionType.FailedToLoadAllFilms:
            return Object.assign(Object.assign({}, state), { isLoadingAllFilms: false, showAllFilms: false });
        case ActionType.LoadedAllFilms:
            return Object.assign(Object.assign({}, state), { isLoadingAllFilms: false });
        case ActionType.SetOldShowtimeIdsForDate:
            return Object.assign(Object.assign({}, state), { oldShowtimeIdsForDate: action.showtimeIds });
        case ActionType.SelectDate:
            return Object.assign(Object.assign({}, state), { selectedBusinessDate: action.date, apiErrorMessageType: undefined });
        case ActionType.SetIsExternalDateTransition:
            return Object.assign(Object.assign({}, state), { isExternalDateTransition: action.isExternalDateTransition });
        case ActionType.ToggleAllFilms:
            return Object.assign(Object.assign({}, state), { showAllFilms: action.showAllFilms });
        default: {
            logger.error(`Unknown DateShowtimePickerAction ${action.type}.`);
            return state;
        }
    }
};
